<template>
    <div
        class="node-palette-item p-3 border rounded-lg cursor-pointer hover:shadow-md transition-all duration-200"
        :class="[
            nodeType.color.replace('bg-', 'border-'),
            isDragging ? 'opacity-50 scale-95' : 'hover:scale-105'
        ]"
        draggable="true"
        @click="handleCreateNode"
        @dragstart="onDragStart"
        @dragend="onDragEnd"
    >
        <div class="flex items-center gap-2">
            <UIcon :name="nodeType.icon" class="text-lg" />
            <div>
                <div class="font-medium text-sm">{{ nodeType.label }}</div>
                <div class="text-xs text-gray-600">{{ nodeType.description }}</div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import type { NodeType } from '@/workflow/types'

const props = defineProps<{
    nodeType: NodeType
}>()

const emit = defineEmits<{
    createNode: [nodeType: NodeType, position?: { x: number, y: number }]
}>()

const isDragging = ref(false)

function handleCreateNode() {
    emit('createNode', props.nodeType)
}

function onDragStart(event: DragEvent) {
    isDragging.value = true
    if (event.dataTransfer) {
        event.dataTransfer.setData('application/vueflow-node', JSON.stringify(props.nodeType))
        event.dataTransfer.effectAllowed = 'copy'

        // Create a custom drag image
        const dragElement = event.target as HTMLElement
        const rect = dragElement.getBoundingClientRect()

        // Set drag image offset to center of element
        event.dataTransfer.setDragImage(
            dragElement,
            rect.width / 2,
            rect.height / 2
        )
    }
}

function onDragEnd() {
    isDragging.value = false
}
</script>
